import React from 'react';
import PropTypes from 'prop-types';

/**
 * @typedef {Object} ActionButtonProps
 * @property {string} label - The text displayed on the button.
 * @property {() => void} onClick - The function to be executed when the button is clicked.
 */

/**
 * A basic, reusable button component styled for common actions like 'edit' or 'add'.
 * Note: The component is named UrlInput in the signature but functions as an Action Button.
 *
 * @param {ActionButtonProps} props - The properties for the button component.
 * @returns {JSX.Element} The rendered button component.
 */
const UrlInput = ({ label, onClick, }) => {
    return (
        <button
            className={`bg-[var(--grey-button)]  text-[var(--primary-text-color)]    text-sm  rounded p-2 text-start w-full
            `}
            onClick={onClick}
        >
            {label}
        </button>
    );
};

export default UrlInput;